import { toCanvas } from 'html-to-image';

const CAPTURE_OPTIONS = {
  pixelRatio: 1,
  skipFonts: true,
  style: { overflow: 'hidden' },
  filter: (node) => {
    if (!node.classList) return true;
    return !node.classList.contains('screenshot-ticket-fab')
      && !node.classList.contains('screenshot-ticket-dialog');
  },
};

export default class ScreenshotService {
  static captureScreen() {
    const appElement = document.querySelector('.v-application');
    if (!appElement) {
      throw new Error('Could not find .v-application element');
    }

    return toCanvas(appElement, {
      ...CAPTURE_OPTIONS,
      width: window.innerWidth,
      height: window.innerHeight,
    }).then((canvas) => new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Canvas toBlob failed'))),
        'image/jpeg',
        0.7,
      );
    }));
  }
}
